(() => {
    if (window.__fenxGlobalForceBound) return;
    window.__fenxGlobalForceBound = true;

    window.FENX_FORCE_NO_FIT = window.FENX_FORCE_NO_FIT ?? false;
    window.FENX_FORCE_CONSENT_NO = window.FENX_FORCE_CONSENT_NO ?? false;

    window.fenxForceNoFitOn = function () {
        window.FENX_FORCE_NO_FIT = true;
        try { localStorage.setItem("fenx_force_no_fit", "1"); } catch {}
    };

    window.fenxForceNoFitLoad = function () {
        try { window.FENX_FORCE_NO_FIT = localStorage.getItem("fenx_force_no_fit") === "1"; } catch {}
    };

    window.fenxForceNoFitOff = function () {
        window.FENX_FORCE_NO_FIT = false;
        try { localStorage.removeItem("fenx_force_no_fit"); } catch {}
    };

    window.fenxForceConsentNoOn = function () {
        window.FENX_FORCE_CONSENT_NO = true;
        try { localStorage.setItem("fenx_force_consent_no", "1"); } catch {}
    };

    window.fenxForceConsentNoLoad = function () {
        try { window.FENX_FORCE_CONSENT_NO = localStorage.getItem("fenx_force_consent_no") === "1"; } catch {}
    };

    window.fenxForceConsentNoOff = function () {
        window.FENX_FORCE_CONSENT_NO = false;
        try { localStorage.removeItem("fenx_force_consent_no"); } catch {}
    };

    window.fenxForceNoFitLoad();
    window.fenxForceConsentNoLoad();
})();

(() => {
    if (window.__fenxPopupFileBound) return;
    window.__fenxPopupFileBound = true;

    const API_BASE = "/apps/store-fenx-app";

    let usersCache = null,
        myUser = null,
        others = [],
        saving = false,
        currentForm = null,
        tokenCreating = false;

    window.FENX_SELECTED_USER_ID = "";
    window.FENX_SELECTED_USER_NAME = "";
    window.FENX_SELECTED_FIT = "";
    window.FENX_SELECTED_HAS_SCAN = undefined;
    window.FENX_PRECREATED_TOKEN_ID = "";
    window.FENX_CONSENT = "";

    function unbox(x) { return x && typeof x === "object" && x !== null && "data" in x ? x.data : x }
    function q(s, r) { return (r || document).querySelector(s) }
    function qa(s, r) { return Array.from((r || document).querySelectorAll(s)) }

    function openPopup(p) {
        p.classList.remove("hidden");
        p.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("rpopup-lock");
        document.body.classList.add("rpopup-lock");
    }
    function closePopup(p) {
        p.classList.add("hidden");
        p.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("rpopup-lock");
        document.body.classList.remove("rpopup-lock");
    }

    function gotoStep(p, idx) {
        const panels = qa(".rpopup__panel", p),
            steps = qa(".rpopup__steps li", p);
        panels.forEach((x, i) => x.classList.toggle("is-active", i === idx));
        steps.forEach((li, i) => {
            li.classList.toggle("is-active", i === idx);
            li.classList.toggle("is-complete", i < idx);
        });
        const prevBtn = p.querySelector(`.rpopup__panel[data-step="${idx}"] [data-rpopup-prev]`);
        if (prevBtn) prevBtn.disabled = (idx === 0);
    }
    function setStepLoading(popup, stepIdx, loading) {
        const btn = popup.querySelector(`.rpopup__panel[data-step="${stepIdx}"] [data-rpopup-next]`);
        if (!btn) return;
        btn.setAttribute("aria-busy", String(loading));
        if (loading) btn.disabled = true;
    }
    function setStepNextEnabled(popup, stepIdx, enabled) {
        const btn = popup.querySelector(`.rpopup__panel[data-step="${stepIdx}"] [data-rpopup-next]`);
        if (!btn) return;
        btn.disabled = !enabled;
    }
    function updateStep0NextEnabled(popup) {
        const u = getSelectedUserObj(popup);
        setStepNextEnabled(popup, 0, !!(u?.id));
    }

    function normHasScan(v) { return v === true || v === "true" || v === 1 || v === "1" }

    function errorEl(p, idx) {
        const panel = p.querySelector(`.rpopup__panel[data-step="${idx}"]`);
        if (!panel) return null;
        let el = panel.querySelector(".rpopup__error");
        if (!el) {
            el = document.createElement("div");
            el.className = "rpopup__error";
            el.style.color = "#c00";
            el.style.marginTop = "6px";
            panel.appendChild(el);
        }
        return el;
    }
    function showError(p, idx, msg) { const el = errorEl(p, idx); if (el) el.textContent = msg || "" }
    function clearError(p, idx) { const el = errorEl(p, idx); if (el) el.textContent = "" }

    async function listUsers() {
        const r = await fetch(`${API_BASE}/scan-users?ts=${Date.now()}`, { headers: { Accept: "application/json" }, cache: "no-store" });
        if (!r.ok) return [];
        const raw = await r.json().catch(() => []),
            list = Array.isArray(raw) ? raw : unbox(raw);
        return Array.isArray(list) ? list : [];
    }
    async function createUser(payload) {
        const r = await fetch(`${API_BASE}/scan-users`, {
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });
        const txt = await r.text();
        let body = null;
        try { body = txt ? JSON.parse(txt) : null } catch {}
        if (!r.ok) throw new Error((body && body.message) || txt || `HTTP ${r.status}`);
        const data = unbox(body || {});
        return data && data.id ? data : body;
    }
    async function createTokenForId(userId) {
        const r = await fetch(`${API_BASE}/scan-users/${encodeURIComponent(userId)}/token`, { method: "POST", headers: { Accept: "application/json" } });
        const txt = await r.text();
        let body = null;
        try { body = txt ? JSON.parse(txt) : null } catch {}
        if (!r.ok) throw new Error((body && body.message) || txt || `HTTP ${r.status}`);
        return unbox(body);
    }
    async function precreateToken(userId) {
        if (!userId || tokenCreating) return;
        tokenCreating = true;
        try {
            const tok = await createTokenForId(userId);
            window.FENX_PRECREATED_TOKEN_ID = tok?.id || "";
        } catch {
            window.FENX_PRECREATED_TOKEN_ID = "";
        } finally {
            tokenCreating = false;
        }
    }

    /** Partition scan users into commercialUser and others using is_commercial_user field */
    function partitionUsers(list) {
        if (!Array.isArray(list)) return { commercialUser: null, others: [] };
        const commercialUser = list.find(u => u.is_commercial_user === true) || null;
        const others = list.filter(u => u.is_commercial_user !== true);
        return { commercialUser, others };
    }
    function renderOthers(container) {
        container.innerHTML = "";
        if (!others.length) {
            container.innerHTML = "<div>No members yet</div>";
            return;
        }
        others.forEach(u => {
            const id = String(u.id || "");
            const label = `${u.first_name || ""} ${u.last_name || ""}`.trim() || id;
            const row = document.createElement("label");
            row.className = "rpopup__radio";
            row.innerHTML = `<input type="radio" name="fenx_existing_id" value="${id}"><span>${label}</span>`;
            container.appendChild(row);
        });
    }
    function setMyselfLabel(popup) {
        const lab = popup.querySelector('input[name="r_assigned_to"][value="Myself"]')?.closest("label");
        if (!lab) return;
        const span = lab.querySelector("span");
        if (span) span.textContent = "Myself";
    }
    async function hydrate(popup) {
        setStepLoading(popup, 0, true);
        try {
            usersCache = await listUsers();
            const parts = partitionUsers(usersCache);
            myUser = parts.commercialUser;
            others = parts.others;
            setMyselfLabel(popup);
            const listBox = q("[data-rpopup-users]", popup) || q(".js-for-Another-Existing-Member [data-rpopup-users]", popup);
            if (listBox) renderOthers(listBox);
        } catch {
            showError(popup, 0, "Could not load members. You can still add someone new.");
        } finally {
            setStepLoading(popup, 0, false);
            updateStep0NextEnabled(popup);
        }
    }
    function toggleGroups(popup) {
        const who = popup.querySelector('input[name="r_assigned_to"]:checked')?.value || "";
        ["Myself", "Another Existing Member", "Someone New"].forEach(key => {
            qa(".js-for-" + key.replace(/ /g, "-"), popup).forEach(el => el.classList.toggle("hidden", key !== who))
        });
    }
    function getSelectedUserObj(popup) {
        const who = popup.querySelector('input[name="r_assigned_to"]:checked')?.value || "";
        if (who === "Myself") return myUser || null;
        if (who === "Another Existing Member") {
            const id = q('input[name="fenx_existing_id"]:checked', popup)?.value || "";
            return usersCache?.find(u => String(u.id) === String(id)) || null;
        }
        if (who === "Someone New") {
            const id = window.FENX__NEW_ID || "";
            return usersCache?.find(u => String(u.id) === String(id)) || null;
        }
        return null;
    }

    function updateStep1View(popup) {
        const noScan = popup.dataset.noscan === "1";
        const fitBox = q(".rpopup__fit-question", popup);
        const needBox = q(".rpopup__scan-needed", popup);
        if (fitBox) fitBox.classList.toggle("hidden", noScan);
        if (needBox) needBox.classList.toggle("hidden", !noScan);
    }

    function bindUI(popup) {
        if (popup.dataset.fenxUiBound === "1") return;
        popup.dataset.fenxUiBound = "1";

        popup.addEventListener("change", e => {
            if (e.target.name === "r_assigned_to") {
                clearError(popup, 0); toggleGroups(popup); updateStep0NextEnabled(popup);
            }
            if (e.target.name === "fenx_existing_id") {
                window.FENX_SELECTED_USER_ID = e.target.value; clearError(popup, 0); updateStep0NextEnabled(popup);
            }
            if (e.target.name === "r_fit") {
                window.FENX_SELECTED_FIT = e.target.value; clearError(popup, 1);
                if (e.target.value === "no") {
                    window.fenxForceNoFitOn();
                    precreateToken(getSelectedUserObj(popup)?.id || "");
                    window.FENX_PRECREATED_TOKEN_ID = window.FENX_PRECREATED_TOKEN_ID || "";
                } else {
                    window.fenxForceNoFitOff();
                    window.FENX_PRECREATED_TOKEN_ID = "";
                }
            }
            if (e.target.name === "r_consent") {
                window.FENX_CONSENT = e.target.value; clearError(popup, 2);
                if (String(e.target.value).toLowerCase() === "no") {
                    window.fenxForceConsentNoOn();
                    window.FENX_CONSENT = "no";
                } else {
                    window.fenxForceConsentNoOff();
                }
            }
        });

        popup.addEventListener("click", async e => {
            const saveBtn = e.target.closest("[data-rpopup-save-new]");
            if (!saveBtn) return;
            if (saving) return;

            const fnEl = q('[name="r_new_first"]', popup);
            const lnEl = q('[name="r_new_last"]', popup);
            const emEl = q('[name="r_new_email"]', popup);
            const inputs = [fnEl, lnEl, emEl];

            saveBtn.classList.remove('with-check');

            if (!inputs.every(el => el && el.checkValidity())) {
                inputs.forEach(el => el && el.reportValidity());
                return;
            }

            const fn = fnEl.value.trim();
            const ln = lnEl.value.trim();
            const em = emEl.value.trim();

            saving = true; saveBtn.disabled = true;
            try {
                const created = await createUser({ first_name: fn, last_name: ln, email: em });
                window.FENX__NEW_ID = String(created.id);
                usersCache = await listUsers();
                const parts = partitionUsers(usersCache);
                myUser = parts.commercialUser; others = parts.others;
                renderOthers(q("[data-rpopup-users]", popup) || q(".js-for-Another-Existing-Member [data-rpopup-users]", popup));

                const another = popup.querySelector('input[name="r_assigned_to"][value="Another Existing Member"]');
                if (another) { another.checked = true; toggleGroups(popup); }
                const radio = q(`input[name="fenx_existing_id"][value="${CSS.escape(window.FENX__NEW_ID)}"]`, popup);
                if (radio) radio.checked = true;
                updateStep0NextEnabled(popup);

                clearError(popup, 0);
                const hint = q('[data-rpopup-new-msg]', popup);
                if (hint) hint.textContent = '';

                fnEl.value = "";
                lnEl.value = "";
                emEl.value = "";
                inputs.forEach(el => {
                    el.classList.remove('rpopup__input-error');
                    el.setAttribute('aria-invalid', 'false');
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                });

                saveBtn.classList.add('with-check');

                const removeCheck = () => saveBtn.classList.remove('with-check');
                inputs.forEach(el => {
                    el.removeEventListener('input', removeCheck);
                    el.addEventListener('input', removeCheck, { once: true });
                });

                fnEl.focus();

            } finally {
                saveBtn.disabled = false; saving = false;
            }
        });

        popup.addEventListener("click", e => {
            const prev = e.target.closest("[data-rpopup-prev]");
            if (!prev) return;
            const idx = qa(".rpopup__panel", popup).findIndex(p => p.classList.contains("is-active"));
            clearError(popup, idx);
            gotoStep(popup, Math.max(0, idx - 1));
        });

        popup.addEventListener("click", e => {
            const next = e.target.closest("[data-rpopup-next]");
            if (!next) return;
            const idx = qa(".rpopup__panel", popup).findIndex(p => p.classList.contains("is-active"));
            if (idx === 0) {
                clearError(popup, 0);
                const who = popup.querySelector('input[name="r_assigned_to"]:checked')?.value || "";
                if (!who) { showError(popup, 0, "Please choose who this is for."); return; }
                const u = getSelectedUserObj(popup);
                if (!(u?.id)) { showError(popup, 0, "Please select or add a member."); return; }
                window.FENX_SELECTED_USER_ID = String(u.id);
                window.FENX_SELECTED_USER_NAME = `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email || String(u.id);
                window.FENX_SELECTED_HAS_SCAN = !!normHasScan(u.hasScan);
                if (!window.FENX_SELECTED_HAS_SCAN) {
                    window.fenxForceNoFitOn();
                    window.FENX_SELECTED_FIT = "";
                    popup.dataset.noscan = "1";
                    precreateToken(String(u.id));
                    gotoStep(popup, 1);
                    updateStep1View(popup);
                } else {
                    popup.dataset.noscan = "0";
                    gotoStep(popup, 1);
                    updateStep1View(popup);
                }
                return;
            }
            if (idx === 1) {
                clearError(popup, 1);
                if (popup.dataset.noscan === "1") {
                    gotoStep(popup, 2);
                    return;
                }
                const fit = popup.querySelector('input[name="r_fit"]:checked')?.value || "";
                if (!fit) { showError(popup, 1, "Please choose an option."); return; }
                window.FENX_SELECTED_FIT = fit;
                if (fit === "no") {
                    window.fenxForceNoFitOn();
                    const u = getSelectedUserObj(popup);
                    precreateToken(u?.id || "");
                }
                gotoStep(popup, 2);
                return;
            }
        });

        popup.addEventListener("click", e => {
            const finish = e.target.closest('[data-rpopup-finish], .rpopup [type="submit"][name="add"]');
            if (!finish) return;
            e.preventDefault();
            e.stopPropagation();
            let consent = popup.querySelector('input[name="r_consent"]:checked')?.value || "";
            if (!consent) { showError(popup, 2, "Please choose an option."); return; }
            consent = String(consent).toLowerCase();
            if (window.FENX_FORCE_CONSENT_NO === true) consent = "no";
            if (consent === "no") window.fenxForceConsentNoOn();
            window.FENX_CONSENT = consent;
            closePopup(popup);
            const form = currentForm || document.querySelector("product-form form, form[action='/cart/add']");
            if (form) {
                form.dataset.fenxOpen = "1";
                form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
                setTimeout(() => { form.dataset.fenxOpen = "0"; }, 0);
            }
        });
    }

    async function closeQuickAddAround(el) {
        const modal = el?.closest('.quick-add-modal[open], modal-dialog[open], .popup-modal[open]')
            || document.querySelector('.quick-add-modal[open], modal-dialog[open], .popup-modal[open]');
        if (!modal) return;
        const closer = modal.querySelector('.quick-add-modal__toggle, .popup-modal__toggle, [aria-label="Close"], [data-close]');
        if (closer) closer.click();
        modal.removeAttribute('open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('popup-open', 'overflow-hidden');
        document.body.classList.remove('popup-open', 'overflow-hidden');
    }

    let POPUP_SINGLETON = null;
    function ensureSingleton() {
        if (POPUP_SINGLETON && document.contains(POPUP_SINGLETON)) return POPUP_SINGLETON;
        const preferred = document.querySelector('.rpopup[data-fenx-global="1"], #recipient-popup-global.rpopup');
        const candidates = preferred ? [preferred] : Array.from(document.querySelectorAll('.rpopup'));
        if (!candidates.length) return null;
        POPUP_SINGLETON = candidates[0];
        if (POPUP_SINGLETON.parentNode !== document.body) {
            document.body.appendChild(POPUP_SINGLETON);
        }
        candidates.slice(1).forEach(x => x.remove());
        return POPUP_SINGLETON;
    }

    function findPopupFor() { return ensureSingleton(); }

    function hookOpen() {
        document.addEventListener('click', e => {
            if (e.target.hasAttribute('data-rpopup-close')) {
                const p = e.target.closest('.rpopup');
                if (p) closePopup(p);
            }
        });

        document.addEventListener('click', async e => {
            if (e.target.closest('[data-rpopup-finish]')) return;
            const btn = e.target.closest("form[action='/cart/add'] [name='add'], product-form form [name='add']");
            if (!btn) return;
            const form = btn.closest('form') || document.querySelector('product-form form, form[action="/cart/add"]');
            if (!form || form.dataset.fenxOpen === '1') return;
            const popup = findPopupFor();
            if (!popup) return;
            e.preventDefault();
            await closeQuickAddAround(btn);
            currentForm = form;
            qa('input[name="r_assigned_to"]', popup).forEach(r => r.checked = false);
            qa('.js-for-Myself,.js-for-Another-Existing-Member,.js-for-Someone-New', popup).forEach(el => el.classList.add('hidden'));
            qa('input[name="r_fit"]', popup).forEach(r => r.checked = false);
            qa('input[name="r_consent"]', popup).forEach(r => r.checked = false);
            popup.dataset.noscan = '0';
            window.FENX_SELECTED_USER_ID = '';
            window.FENX_SELECTED_USER_NAME = '';
            window.FENX_SELECTED_FIT = '';
            window.FENX_SELECTED_HAS_SCAN = undefined;
            window.FENX_PRECREATED_TOKEN_ID = '';
            window.FENX_CONSENT = '';
            window.fenxForceNoFitOff();
            window.fenxForceConsentNoOff();
            window.FENX__NEW_ID = '';
            clearError(popup, 0); clearError(popup, 1); clearError(popup, 2);
            gotoStep(popup, 0);
            openPopup(popup);
            updateStep1View(popup);
            setStepLoading(popup, 0, true);
            usersCache = null; myUser = null; others = [];
            hydrate(popup);
            bindUI(popup);
        });
    }

    function init() {
        ensureSingleton();
        new MutationObserver(ms => {
            for (const m of ms) {
                for (const n of m.addedNodes) {
                    if (n.nodeType !== 1) continue;
                    if (n.matches?.('.rpopup') && n !== POPUP_SINGLETON) n.remove();
                    n.querySelectorAll?.('.rpopup').forEach(x => { if (x !== POPUP_SINGLETON) x.remove(); });
                }
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
        hookOpen();
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

(() => {
    if (window.__fenxSubmitFileBound) return;
    window.__fenxSubmitFileBound = true;

    const API_BASE = "/apps/store-fenx-app";
    let submitting = false;

    function setHidden(form, name, value) {
        const sel = `input[name="${name}"]`;
        let el = form.querySelector(sel);
        if (value === void 0 || value === null || value === "") {
            if (el) el.remove();
            return;
        }
        if (!el) {
            el = document.createElement("input");
            el.type = "hidden";
            el.name = name;
            form.appendChild(el);
        }
        el.value = String(value);
    }

    function unbox(x) { return x && typeof x === "object" && x !== null && "data" in x ? x.data : x }

    async function listUsers() {
        const r = await fetch(`${API_BASE}/scan-users?ts=${Date.now()}`, { headers: { Accept: "application/json" }, cache: "no-store" });
        if (!r.ok) return [];
        const raw = await r.json().catch(() => []),
            list = Array.isArray(raw) ? raw : unbox(raw);
        return Array.isArray(list) ? list : [];
    }

    async function resolveUser() {
        const users = await listUsers();
        const commercialUser = users.find(u => u.is_commercial_user === true) || null;
        const chosenId = window.FENX_SELECTED_USER_ID || (commercialUser?.id ? String(commercialUser.id) : "");
        const u = users.find(x => String(x.id) === String(chosenId)) || commercialUser || null;
        const hasScan = !!(u && (u.hasScan === true || u.hasScan === "true" || u.hasScan === 1 || u.hasScan === "1"));
        const leftScanId = hasScan && u?.scan_left?.id ? String(u.scan_left.id) : "";
        const rightScanId = hasScan && u?.scan_right?.id ? String(u.scan_right.id) : "";
        return { id: chosenId || (u?.id ? String(u.id) : ""), hasScan, leftScanId, rightScanId };
    }

    async function createTokenForId(userId) {
        const r = await fetch(`${API_BASE}/scan-users/${encodeURIComponent(userId)}/token`, { method: "POST", headers: { Accept: "application/json" } });
        const txt = await r.text();
        let body = null;
        try { body = txt ? JSON.parse(txt) : null } catch {}
        if (!r.ok) {
            const e = new Error((body && body.message) || txt || `HTTP ${r.status}`);
            e.status = r.status;
            throw e;
        }
        return unbox(body);
    }

    async function getCart() {
        const r = await fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
        if (!r.ok) throw new Error("Cannot load cart");
        return await r.json();
    }

    async function changeLine(line, properties) {
        const r = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ line, properties })
        });
        if (!r.ok) throw new Error("Cannot change line " + line);
        return await r.json();
    }

    async function syncExistingCartLines(targetUserId, consent, fit, tokenId, leftScanId, rightScanId) {
        const cart = await getCart();
        const items = cart?.items || [];
        for (let i = 0; i < items.length; i++) {
            const props = items[i]?.properties || {};
            if (props._scan_user_id !== targetUserId) continue;

            // Nothing changed for this item — skip
            if (props._scan_consent === consent && props._scan_user_fit === fit) continue;

            // Rebuild properties to match the item we're about to add.
            // We branch on the NEW fit value, which handles both directions:
            //   yes → no: remove scan IDs, assign token (user needs rescan)
            //   no → yes: remove token, assign scan IDs (user has valid scan)
            // Consent is always set to the current value regardless of direction.
            const merged = Object.assign({}, props);
            merged._scan_consent = consent;
            merged._scan_user_fit = fit;
            if (fit === "yes") {
                merged._left_scan_id = leftScanId;
                merged._right_scan_id = rightScanId;
                delete merged._scan_token_id;
            } else {
                merged._scan_token_id = tokenId;
                delete merged._left_scan_id;
                delete merged._right_scan_id;
            }
            await changeLine(i + 1, merged);
        }
    }

    async function fenxAutoResetIfCartEmpty() {
        let cart = null;
        try { cart = await getCart(); } catch {}
        if (!cart) return;
        if ((cart.item_count || 0) === 0) {
            window.fenxForceNoFitOff();
            window.fenxForceConsentNoOff();
        }
    }

    async function onSubmit(ev) {
        const form = ev.target;
        if (form.dataset.fenxPass === "1") return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (submitting) return;
        submitting = true;

        try {
            form.querySelectorAll('input[name^="properties["]').forEach(el => el.remove());

            const selectedFlag = typeof window.FENX_SELECTED_HAS_SCAN === "boolean" ? window.FENX_SELECTED_HAS_SCAN : void 0;
            const { id: userId, hasScan, leftScanId, rightScanId } = await resolveUser();
            const effectiveHasScan = typeof selectedFlag === "boolean" ? selectedFlag : hasScan;

            let fit = (window.FENX_SELECTED_FIT || "").toLowerCase();
            if (window.FENX_FORCE_NO_FIT === true) fit = "no";
            if (fit === "no") window.fenxForceNoFitOn();

            let consent = String(window.FENX_CONSENT || "").toLowerCase();
            if (window.FENX_FORCE_CONSENT_NO === true) consent = "no";
            if (consent === "no") window.fenxForceConsentNoOn();

            let tokenId = window.FENX_PRECREATED_TOKEN_ID || "";

            setHidden(form, "properties[_scan_user_id]", userId || "");
            setHidden(form, "properties[_scan_consent]", consent || "");
            setHidden(form, "properties[Recipient]", window.FENX_SELECTED_USER_NAME || "");

            // Determine fit: no scan means fit=no
            if (!effectiveHasScan) fit = "no";

            // Set up form hidden fields based on fit
            if (fit === "yes") {
                setHidden(form, "properties[_scan_user_fit]", "yes");
                setHidden(form, "properties[_left_scan_id]", leftScanId || "");
                setHidden(form, "properties[_right_scan_id]", rightScanId || "");
                setHidden(form, "properties[_scan_token_id]", "");
            } else if (fit === "no") {
                if (!tokenId && userId) {
                    try { tokenId = (await createTokenForId(userId))?.id || "" } catch {}
                }
                setHidden(form, "properties[_scan_user_fit]", "no");
                setHidden(form, "properties[_scan_token_id]", tokenId);
                setHidden(form, "properties[_left_scan_id]", "");
                setHidden(form, "properties[_right_scan_id]", "");
            } else {
                setHidden(form, "properties[_scan_user_fit]", "");
                setHidden(form, "properties[_left_scan_id]", "");
                setHidden(form, "properties[_right_scan_id]", "");
                setHidden(form, "properties[_scan_token_id]", "");
            }

            // Sync existing cart items for this user if consent or fit changed.
            // One cart fetch, one loop — only calls changeLine when a diff exists.
            //
            // NOTE: We do not handle the case where a user completes their
            // scan between adds (no-scan → has-scan). That would require a
            // UX prompt ("User X now has a scan, assign it?") which is out
            // of scope for now.
            try {
                await syncExistingCartLines(userId, consent, fit, tokenId, leftScanId, rightScanId);
            } catch {}

        } finally {
            form.dataset.fenxPass = "1";
            submitting = true;
            form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
            form.dataset.fenxPass = "0";
            submitting = false;
            setTimeout(() => { fenxAutoResetIfCartEmpty(); }, 600);
        }
    }

    function bind(form) {
        if (!form || form.dataset.fenxBound) return;
        form.dataset.fenxBound = "1";
        form.addEventListener("submit", onSubmit, true);
    }

    function init() {
        fenxAutoResetIfCartEmpty();
        const selectors = ["product-form form", "form[action='/cart/add']"];
        const forms = new Set();
        selectors.forEach(sel => { try { document.querySelectorAll(sel).forEach(f => forms.add(f)) } catch {} });
        forms.forEach(bind);
        new MutationObserver(ms => {
            for (const m of ms) {
                for (const n of m.addedNodes) {
                    if (n.nodeType !== 1) continue;
                    if (n.matches?.("form[action='/cart/add'], product-form form")) bind(n);
                    n.querySelectorAll?.("form[action='/cart/add'], product-form form").forEach(bind);
                }
            }
        }).observe(document.documentElement, { childList: true, subtree: true });
    }

    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();

